<template>
  <section>
    <errors-list :errorMessage="errorMessage" />

    <v-data-table
      :headers="translatedHeaders"
      :items="items"
      :loading="loading"
      :rows-per-page-items="rowsPerPageItems"
      :total-items="pagination.totalItems"
      :pagination.sync="pagination"
      item-key="_id"
    >
      <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <tr>
          <template :header="header" :row="props.item" v-for="(header, index) in translatedHeaders">
            <td v-if="header.value === 'type'" :key="index">
              <div>{{ localizedType(props.item.type) }}</div>
            </td>
            <td v-else-if="header.value === 'comment'" :key="index + 'comment'">
              <a
                v-if="props.item.comment"
                @click="(dialog = true), (dialogMessage = props.item.comment)"
              >
                <div class="comment">
                  {{ props.item.comment }}
                </div>
              </a>
            </td>
            <td v-else-if="header.value === 'byEmployee'" :key="index + 'byEmployee'">
              <span>{{ createdBy(props.item.byEmployee) }}</span>
            </td>
            <grid-cell v-else :header="header" :row="props.item" :key="index + 'else'"></grid-cell>
          </template>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" persistent max-width="480">
      <v-card>
        <v-card-text>
          <code class="pa-2 comment-dialog">{{ dialogMessage }}</code>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            class="ma-2"
            text
            dark
            @click="(dialog = false), (dialogMessage = '')"
          >
            {{ $t('@newContractForm/close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import ErrorsList from '../../components/ErrorsList';
import GridCell from '../../components/GridCell';
import { WinbackTypes } from '../../constants';
import { getErrorMessage } from '../../errorHandlers';
import { defaultDateTimeFormatter, serializeQuery } from '../../utils';
import { WINBACK_CREATED } from '../../wsEventTypes';

const defaultHeaders = [
  {
    text: '@auditTrailEventsList/createdAtColumnHeader',
    value: 'createdAt',
    format: defaultDateTimeFormatter,
    sortable: false,
  },
  {
    text: '@auditTrailEventsList/typeColumnHeader',
    value: 'type',
    sortable: false,
    format: (value) => (value ? WinbackTypes[value] : ''),
  },
  {
    text: '@auditTrailEventsList/messageColumnHeader',
    value: 'comment',
    sortable: false,
  },
  {
    text: '@auditTrailEventsList/userColumnHeader',
    value: 'byEmployee',
    sortable: false,
  },
];

export default {
  components: { GridCell, ErrorsList },

  props: {
    contract: {
      type: Object,
    },
    headers: {
      type: Array,
      default: () => defaultHeaders,
    },
  },

  watch: {
    pagination() {
      this.fetchData();
    },
  },

  data() {
    return {
      lastQueryString: '',
      errorMessage: '',
      loading: false,
      items: [],
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
      },
      rowsPerPageItems: [10, 15, 50, 100],
      dialog: false,
      dialogMessage: '',
    };
  },

  computed: {
    translatedHeaders() {
      return Array.isArray(this.headers)
        ? this.headers.map((h) => ({
            ...h,
            text: this.$t(h.text),
          }))
        : [];
    },

    query() {
      const skip = (this.pagination.page - 1) * this.pagination.rowsPerPage;
      const take = this.pagination.rowsPerPage;
      const query = {
        skip,
        take,
      };

      return query;
    },
  },

  methods: {
    async fetchData(force) {
      const qs = serializeQuery(this.query);

      if (!force && (this.lastQueryString === qs || this.loading)) {
        return;
      }

      try {
        this.loading = true;
        const {
          data: { data, meta },
        } = await this.$http.get(`/api/insurances/${this.contract.id}/winback?${qs}`);

        this.items = data || [];
        this.lastQueryString = qs;
        this.pagination.totalItems = meta.total;

        this.errorMessage = '';
      } catch (e) {
        this.errorMessage = getErrorMessage(e);
      } finally {
        this.loading = false;
      }
    },

    createdBy(user) {
      return user
        ? `${user.firstName} ${user.lastName}`
        : this.$t('@auditTrailEventsList/systemUserName');
    },

    localizedType(type) {
      return type ? this.$t(`@winbackForm/${type}`) : '';
    },
  },
  sockets: {
    insuranceSubscribe: function(data) {
      const eventTypes = [WINBACK_CREATED];
      if (
        data.meta &&
        eventTypes.includes(data.type) &&
        this.items.find((el) => el.contractId === data.meta.contractId)
      ) {
        this.lastQueryString = '';
        this.fetchData();
      }
    },
  },
};
</script>

<style scoped>
code {
  width: 100%;
}
.comment {
  text-overflow: ellipsis;
  max-width: 200px;
  height: 20px;
  white-space: nowrap;
  overflow: hidden;
}
.comment:hover {
  text-decoration: underline;
}
.comment-dialog {
  word-break: break-word;
}
</style>
